import React from 'react';
import RenderRoutes from './pages';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from "./features/mui/theme"
import Apollo from './features/apollo';
import ErrorBoundary from "./features/errorHandling/ErrorBoundary";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <ErrorBoundary>
          <Apollo>
            <RenderRoutes />
          </Apollo>
        </ErrorBoundary>
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;
